import * as React from 'react';
import { setDisplayName, getDisplayName } from 'recompose';
export function createControllerContextHocs(Provider, Consumer) {
    const withProvider = () => (WrappedComponent) => {
        const WithProvider = props => (React.createElement(Provider, null,
            React.createElement(WrappedComponent, Object.assign({}, props))));
        return setDisplayName(`withControllerProvider(${getDisplayName(Provider)})`)(WithProvider);
    };
    function withConsumer(mapProps) {
        return (WrappedComponent) => {
            const WithConsumer = props => (React.createElement(Consumer, null, value => {
                const mappedProps = mapProps(value.state, value.controller, value.props);
                return React.createElement(WrappedComponent, Object.assign({}, props, mappedProps));
            }));
            return setDisplayName(`withControllerConsumer(${getDisplayName(Consumer)})`)(WithConsumer);
        };
    }
    return {
        withProvider,
        withConsumer
    };
}
//# sourceMappingURL=createControllerContextHocs.js.map